const styles = theme => ({
  dialogContainer: {
    maxWidth: "510px",
    width: "100%",
    margin: "0 auto",
    boxShadow: "none",
    position: "relative"
  },
  dialogTitle: {
    "& h6": {
      fontFamily: "Titillium-Regular, Helvetica Neue, sans-serif",
      fontSize: "18px",
      color: "#323233",
      display: "flex",
      justifyContent: "space-between"
    }
  },
  dialogInputContainer: {
    padding: "0 24px 15px"
  },
  dialogInput: {
    marginBottom: "15px"
  },
  dialogButtonContainer: {
    paddingLeft: "10px",
    justifyContent: "flex-start",
    "& div": {
      display: "block",
      width: "100%"
    },
    "& button": {
      fontFamily: "Titillium-SemiBold, Helvetica Neue, sans-serif",
      marginBottom: "20px",
      [theme.breakpoints.down("xs")]: {
        width: "calc(100% - 20px)"
      }
    }
  },
  dialogSubmitButton: {
    fontSize: "14px",
    fontFamily: "Titillium-SemiBold, Helvetica Neue, sans-serif",
    textTransform: "uppercase",
    marginBottom: "32px",
    height: "40px"
  },

  popupTitle: {
    "& h6": {
      fontSize: "22px",
      fontFamily: "Titillium-SemiBold, Helvetica Neue, sans-serif",
      color: "#323233",
      paddingBottom: "8px",
      borderBottom: "1px solid #d8d8d8",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    "& span": {
      color: "#ff3f79"
    }
  },
  popupBuyerTitle: {
    "& h6": {
      fontSize: "26px",
      paddingBottom: "15px"
    },
    "& svg": {
      cursor: "pointer"
    }
  },
  gridRow: {
    width: "calc(510px - 48px)",
    [theme.breakpoints.down("xs")]: {
      width: "100%"
    },
    "& div": {
      marginBottom: "5px",
      [theme.breakpoints.down("xs")]: {
        paddingRight: "0"
      }
    }
  },
  fieldGridLeft: {
    paddingRight: "30px",
    [theme.breakpoints.down("xs")]: {
      paddingRight: "0"
    }
  },
  fieldGridRight: {
    paddingLeft: "30px",
    [theme.breakpoints.down("xs")]: {
      paddingLeft: "0"
    }
  },
  buyerPopupDetails: {
    width: "calc(511px - 24px)",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    position:"relative",
    [theme.breakpoints.down("xs")]: {
      width: "100%"
    },

    "& div": {
      [theme.breakpoints.down("xs")]: {
        width: "100%"
      }
    },
    "& h3": {
      fontSize: "14px",
      color: "#323233",
      textTransform: "uppercase",
      fontFamily: "Titillium-SemiBold, Helvetica Neue, sans-serif",
      margin: "10px 0 20px 0",
      "& span": {
        fontSize: "13px",
        color: "#323233",
        fontFamily: "Titillium-Regular, Helvetica Neue, sans-serif",
        textTransform: "initial",
        marginLeft: "5px",
        [theme.breakpoints.up("sm")]: {
          display: "none"
        }
      }
    }
  },

  Infocard: {
    background: "none",
    boxShadow: "none",
    marginBottom: "20px",
    width: "100%",
    "& h6": {
      fontSize: "12px",
      color: "#232323",
      margin: "0",
      fontFamily: "Titillium-Regular, Helvetica Neue, sans-serif"
    },
    "& h5": {
      fontSize: "16px",
      color: "#585858",
      margin: "0",
      fontFamily: "Titillium-Regular, Helvetica Neue, sans-serif"
    },

    "& h4": {
      fontSize: "13px",
      color: "#323233",
      fontFamily: "Titillium-Regular, Helvetica Neue, sans-serif",
      marginTop: "2px",
      textAlign: "center",
      [theme.breakpoints.down("xs")]: {
        display: "none"
      }
    },

    "& img": {
      maxWidth: "163px",
      maxHeight: "163px",
      [theme.breakpoints.down("xs")]: {
        maxWidth: "100%"
      }
    }
  },
  //review section
  buyerReviewSection: {
    "& h4": {
      fontSize: "16px",
      textTransform: "uppercase",
      color: "#101010",
      fontFamily: "Titillium-Regular, Helvetica Neue, sans-serif",
      marginTop: "20px",
      marginBottom: "15px"
    }
  },
  ReviewTitle: {
    fontSize: "16px",
    color: "#323233",
    fontFamily: "Titillium-SemiBold, Helvetica Neue, sans-serif",
    maxWidth: "calc(100% - 90px)",
    [theme.breakpoints.down("xs")]: {
      maxWidth: "100%"
    }
  },

  Rating: {
    "& svg": {
      fontSize: "18px",
      color: "#c1c3c7"
    }
  },
  ActiveRating: {
    color: "#ffcc4d!important"
  },

  ReviewContent: {
    fontSize: "13px",
    fontFamily: "Titillium-Regular, Helvetica Neue, sans-serif",
    color: "#323233",
    lineHeight: "21px",
    marginBottom: "10px"
  },
  ReviewDate: {
    color: "#58637d",
    fontSize: "11px",
    fontFamily: "Titillium-LightItalic, Helvetica Neue, sans-serif"
  },

  RatingWrap: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "15px"
  },
  ReviewBlock: {
    background: "#fff",
    boxShadow: "0 13px 34px 0 rgba(88, 99, 125, 0.1);",
    padding: "15px 26px",
    marginBottom: "11px"
  },
  popupLoader: {
    height: "200px",
    width: "90%",
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  dialogContent: {
    width: "500px",
    minHeight: "200px",
    [theme.breakpoints.down("xs")]: {
      width: "auto"
    }
  }
});
export default styles;
